import { uri } from '../../api-endpoint';
import { IProjectSummaryFromAPISuccessResponse } from '../../type-conversion/project-summary/from-api-response';
import { getTemplateFn } from '../common/base/fetch-without-body-template-fn';

export const getProjectSummary = (token: string) => (projectId: number) =>
  getTemplateFn(
    token,
    uri.projectSummary(projectId),
    IProjectSummaryFromAPISuccessResponse
  );
